import React from 'react';
import {Helper} from 'Helpers';
import './Controls.scss';

let BibleReferenceUtility;

class Controls extends React.Component {
  constructor(props) {
    super(...arguments);

    let sortBy = props.section.prop('options')
      ? props.section.prop('options').sort_by || 'display_date'
      : 'display_date';
    let sortDirection = props.section.prop('options')
      ? props.section.prop('options').sort_direction || 'DESC'
      : 'DESC';
    let qs = new URLSearchParams(window.location.search);
    let categories = FW.store.get(
      'section-' + props.section.get('id') + '-categories'
    );
    let tags = FW.store.get(
      'section-' + props.section.get('id') + '-tags'
    );
    let series = FW.store.get('section-' + props.section.get('id') + '-series');
    let authors = FW.store.get(
      'section-' + props.section.get('id') + '-authors'
    );
    let years = FW.store.get('section-' + props.section.get('id') + '-years');
    let mediaSeriesId =
      qs.get('media_series') !== 'undefined' &&
      qs.get('media_series') !== 'null'
        ? qs.get('media_series')
        : null;
    let seriesTitle = series.findWhere({id: mediaSeriesId})
      ? series.findWhere({id: mediaSeriesId}).get('title')
      : 'All Series';
    let mediaCategoryId =
      qs.get('categories') !== 'undefined' &&
      qs.get('categories') !== 'null' &&
      qs.get('categories') !== null
        ? qs.get('categories')
        : props.section.prop('options').default_category_id || null;
    let categoryTitle = categories.findWhere({id: mediaCategoryId})
      ? categories.findWhere({id: mediaCategoryId}).get('title')
      : 'All Categories';

    let mediaTagId =
      qs.get('tags') !== 'undefined' &&
      qs.get('tags') !== 'null' &&
      qs.get('tags') !== null
        ? qs.get('tags')
        : props.section.prop('options').default_tag_id || null;
    let tagTitle = tags.findWhere({id: mediaTagId})
      ? tags.findWhere({id: mediaTagId}).get('title')
      : 'All Tags';
    let yearId =
      qs.get('year') !== 'undefined' && qs.get('year') !== 'null'
        ? qs.get('year')
        : null;
    if (yearId === null && typeof props.section.prop('options').default_year !== 'undefined' && props.section.prop('options').default_year !== null && qs.get('year') !== 'null') {
      yearId = props.section.prop('options').default_year.toString();
    }

    let author =
      qs.get('author') !== 'undefined' && qs.get('author') !== 'null'
        ? qs.get('author')
        : null;
    let reference_range =
      qs.get('reference_range') !== 'undefined' &&
      qs.get('reference_range') !== 'null'
        ? qs.get('reference_range')
        : null;
    let yearTitle = 'All Years';
    if (yearId) {
      yearTitle = years.findWhere({year: parseInt(yearId.substring(0, 4), 10)})
        ? years
            .findWhere({year: parseInt(yearId.substring(0, 4), 10)})
            .get('year')
        : 'All Years';
    }

    import(/* webpackPrefetch: true */ 'Editor/Fields/Components/BibleReferenceUtility').then(
      ImportedModule => {
        BibleReferenceUtility = ImportedModule.default;
      }
    );

    this.state = {
      categories,
      tags,
      series,
      authors,
      years,
      query: {
        media_series: mediaSeriesId,
        categories: mediaCategoryId,
        year: yearId,
        author: author,
        reference_range
      },
      sortBy,
      sortByTitle: Helper.titleCase(sortBy),
      sortOrder: sortDirection,
      sortOrderTitle: sortDirection === 'DESC' ? 'Descending' : 'Ascending',
      displayValues: {
        categories: categoryTitle,
        tags: tagTitle,
        media_series: seriesTitle,
        year: yearTitle,
        author: author
      },
      search: '',
      searchingFor: '',
      doneTypingInterval: 500
    };
    this.typingTimer = null;
  }

  queryChanged(key, value, text) {
    let query = this.state.query;
    query[key] = value;
    let displayValues = this.state.displayValues;
    displayValues[key] = text;
    this.setState({
      query: query,
      displayValues: displayValues
    });
    this.props.onChange(query);
  }

  sortChanged(field, name) {
    this.setState({
      sortBy: field,
      sortByTitle: name
    });
    this.props.onSort(field, this.state.sortOrder);
  }

  sortOrderChanged(sort, title) {
    this.setState({
      sortOrderTitle: title,
      sortOrder: sort
    });
    this.props.onSort(this.state.sortBy, sort);
  }

  showPodcastButtons = () => {
    this.setState({
      showPodcastButtons: true
    });
  };

  searchForText = (e) => {
    const v = e.target.value;
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.queryChanged('title', v);
    }, 500);
  }

  search = e => {
    clearTimeout(this.typingTimer);
    this.setState({
      search: e.target.value
    });
    this.typingTimer = setTimeout(() => {
      let value = this.state.search;
      const expanded = BibleReferenceUtility.expandPassage(value);
      let searchingFor = '';
      if (expanded.expanded) {
        const min = BibleReferenceUtility.getMin(expanded.expanded);
        const max = BibleReferenceUtility.getMax(expanded.expanded);
        this.queryChanged(
          'reference_range',
          `${min}|${max}`,
          expanded.expanded
        );
        searchingFor = expanded.expanded;
      } else {
        this.queryChanged('reference_range', null, '');
        searchingFor = expanded.error;
      }
      this.setState({
        searchingFor: searchingFor
      });
    }, this.state.doneTypingInterval);
  };

  render() {
    let categories = this.state.categories
      ? this.state.categories.map(category => {
        return (
          <li
            key={category.get('id')}
            onClick={this.queryChanged.bind(
              this,
              'categories',
              category.get('id'),
              category.get('title')
            )}
          >
            <a>{category.get('title')}</a>
          </li>
        );
      })
      : null;

    let tags = this.state.tags
      ? this.state.tags.map(tag => {
        return (
          <li
            key={tag.get('id')}
            onClick={this.queryChanged.bind(
              this,
              'tags',
              tag.get('id'),
              tag.get('title')
            )}
          >
            <a>{tag.get('title')}</a>
          </li>
        );
      })
      : null;

    let series = this.state.series
      ? this.state.series.map(s => {
          return (
            <li
              key={s.get('id')}
              onClick={this.queryChanged.bind(
                this,
                'media_series',
                s.get('id'),
                s.get('title')
              )}
            >
              <a>{s.get('title')}</a>
            </li>
          );
        })
      : null;

    let years = this.state.years
      ? this.state.years.map((y, k) => {
          let value =
            y.get('year') +
            '-01-01' +
            ' 00:00:00|' +
            y.get('year') +
            '-12-31 23:59:59';
          return (
            <li
              key={k}
              onClick={this.queryChanged.bind(
                this,
                'year',
                value,
                y.get('year')
              )}
            >
              <a>{y.get('year')}</a>
            </li>
          );
        })
      : null;

    let authors = this.state.authors
      ? this.state.authors.map((author, i) => {
        let authorDisplay;
        try {
          authorDisplay = typeof author.get('author') === 'string' ? author.get('author_last') + ', ' + author.get('author').replace(' ' + author.get('author_last'), '') : author.get('author');
        } catch (e) {
          console.log('ERROR RENDERING AUTHOR: ', e);
          authorDisplay = author.get('author');
        }
          return (
            <li
              key={i}
              onClick={this.queryChanged.bind(
                this,
                'author',
                author.get('author'),
                author.get('author')
              )}
            >
              <a>{authorDisplay}</a>
            </li>
          );
        })
      : null;

    const isSermonLibrary = this.props.isSermonLibrary;
    const showPassageSearch = this.props.showPassageSearch;

    return (
      <div className="controls">
        {this.state.showPodcastButtons ? <div className="podcast-wrapper">
          <h4>Subcribe to Podcast</h4>
          <span className="control-label">RSS URL</span>
          <input
            className="form-control"
            id={`rss-input-${this.props.library.get('id')}`}
            style={{width: '80%', margin: 'auto', marginTop: 10, marginBottom: 10}}
            //disabled
            value={window.location.origin + '/feeds/media-libraries/' + this.props.library.get('id')}
            onClick={() => {
              document.getElementById(`rss-input-${this.props.library.get('id')}`).select();
            }}
            onChange={()=>{}}
          />
          {this.props.library.get('apple_podcast_url') ? <a href={this.props.library.get('apple_podcast_url')} style={{margin: 10, marginBottom: 40, display: 'inline-block'}}>
            <img src="/images/podcast-buttons/apple.svg" style={{width: 200}} />
          </a> : null}
          {this.props.library.get('google_podcast_url') ? <a href={this.props.library.get('google_podcast_url')} style={{margin: 10, marginBottom: 30, display: 'inline-block'}}>
            <img src="/images/podcast-buttons/google.svg" style={{width: 200}} />
          </a> : null}
          <div style={{width: 50, height: 40, right: 0, top: 0, position: 'absolute'}} onClick={()=>{this.setState({showPodcastButtons: false})}}>
            <span className="close" style={{fontSize: 50, fontWeight: '100', transform: 'rotate(45deg)'}}>+</span>
          </div>
        </div> : null}
        <div className="dropdown media-categories" style={{padding: 5}}>
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
          >
            {this.state.displayValues.categories}
            <span className="caret"/>
          </button>
          <ul className="dropdown-menu">
            <li
              onClick={this.queryChanged.bind(
                this,
                'categories',
                null,
                'All Categories'
              )}
            >
              <a>All Categories</a>
            </li>
            {categories}
          </ul>
        </div>
        <div className="dropdown media-tags" style={{padding: 5}}>
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
          >
            {this.state.displayValues.tags}
            <span className="caret"/>
          </button>
          <ul className="dropdown-menu">
            <li
              onClick={this.queryChanged.bind(
                this,
                'tags',
                null,
                'All Tags'
              )}
            >
              <a>All Tags</a>
            </li>
            {tags}
          </ul>
        </div>
        <div className="dropdown media-years" style={{padding: 5}}>
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
          >
            {this.state.displayValues.year}
            <span className="caret"/>
          </button>
          <ul className="dropdown-menu">
            <li
              onClick={this.queryChanged.bind(this, 'year', null, 'All Years')}
            >
              <a>All Years</a>
            </li>
            {years}
          </ul>
        </div>
        {!this.props.section.prop('hide_series_dropdown') ? <div className="dropdown media-series" style={{padding: 5}}>
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
          >
            {this.state.displayValues.media_series}
            <span className="caret" />
          </button>
          <ul className="dropdown-menu">
            <li
              onClick={this.queryChanged.bind(
                this,
                'media_series',
                null,
                'All Series'
              )}
            >
              <a>All Series</a>
            </li>
            {series}
          </ul>
        </div> : null}
        <div className="dropdown media-authors" style={{padding: 5}}>
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
          >
            By: {this.state.displayValues.author || 'All'}
            <span className="caret" />
          </button>
          <ul className="dropdown-menu">
            <li onClick={this.queryChanged.bind(this, 'author', null, 'All')}>
              <a>All</a>
            </li>
            {authors}
          </ul>
        </div>
        <div style={{float: 'right'}}>
          {this.props.section.prop('hide_search_button') ? null : <div className="btn btn-primary" onClick={() => {
            this.setState({searching: true});
          }} style={{marginRight: 10, paddingRight: this.state.searching ? 30 : null}}>
            <span className="fa fa-search"></span>
            <span className="search-text" style={{display: 'none'}}>&nbsp;Search...</span>
            {this.state.searching ? <input onChange={this.searchForText} className="form-control" style={{marginLeft: 10, height: 20, display: 'inline-block'}} placeholder="Search For..." /> : null}
          </div>}
          <div className="dropdown" style={{padding: 5}}>
            <button
              className="btn btn-primary dropdown-toggle"
              type="button"
              data-toggle="dropdown"
            >
              {this.state.sortByTitle}
              <span className="caret" />
            </button>
            <ul className="dropdown-menu">
              <li
                onClick={this.sortChanged.bind(
                  this,
                  'display_date',
                  'Display Date'
                )}
              >
                <a>Display Date</a>
              </li>
              <li onClick={this.sortChanged.bind(this, 'title', 'Title')}>
                <a>Title</a>
              </li>
              <li onClick={this.sortChanged.bind(this, 'author_last', 'Author')}>
                <a>Author</a>
              </li>
            </ul>
          </div>
          <div className="dropdown" style={{padding: 5}}>
            <button
              className="btn btn-primary dropdown-toggle"
              type="button"
              data-toggle="dropdown"
            >
              {this.state.sortOrderTitle}
              <span className="caret" />
            </button>
            <ul className="dropdown-menu">
              <li
                onClick={this.sortOrderChanged.bind(this, 'ASC', 'Ascending')}
              >
                <a>Ascending</a>
              </li>
              <li
                onClick={this.sortOrderChanged.bind(this, 'DESC', 'Descending')}
              >
                <a>Descending</a>
              </li>
            </ul>
          </div>
          {this.props.hideRssButton ? null : <li
            className="btn btn-primary"
            onClick={this.showPodcastButtons}
          >
            <span className="fa fa-rss" />
          </li>}
        </div>
        <div style={{width: '100%'}}>
          {isSermonLibrary && showPassageSearch ? (
            <div style={{padding: 5, display: 'inline-block', float: 'left'}}>
              <div className="search-box" style={{display: 'inline-block'}}>
                <input
                  type="text"
                  placeholder="Search by passage"
                  onChange={this.search}
                  value={this.state.search}
                />
                {this.state.search ? (
                  <p style={{display: 'inline-block', marginLeft: 10}}>
                    {this.state.searchingFor}
                  </p>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Controls;
